<template>
  <div :class="ui.root">
    <AwSkeleton :class="ui.checkbox" />
    <div :class="ui.body">
      <AwSkeleton :class="ui.badge" />
      <AwSkeleton :class="ui.badge" />
      <AwSkeleton :class="ui.name" />
    </div>
    <div :class="ui.meta">
      <AwSkeleton :class="ui.date" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { AwSkeleton } from "@asap/design";

const ui = {
  root: "flex items-center gap-2 px-3 py-2 min-h-10",
  checkbox: "size-4 shrink-0 rounded",
  body: "flex min-w-0 flex-1 items-center gap-2 overflow-hidden",
  badge: "h-6 w-16 shrink-0 rounded-sm",
  name: "h-4 w-40 max-w-full rounded-sm",
  meta: "flex items-center shrink-0 ml-auto",
  date: "h-3 w-14 rounded-sm",
};
</script>
